import { useFormikContext } from 'formik';

import { i18, translationGroups, trb } from '../../../../../Utilities';
import { FormField, Input, ToggleButton } from 'src/shared';
import { PAYER_PAYEE_TYPES } from 'src/constants';
import { IPaymentNewValues } from '../../interfaces';
import { FieldIdentificationType } from '../FieldIdentificationType';

export const InitialPayerInformation = () => {
  const { values }: { values: IPaymentNewValues } = useFormikContext();

  return (
    <div>
      <FormField
        name="Payment.InitPayerType"
        label={trb(i18.Labels.InitPayerType)}
        floating={false}
      >
        <ToggleButton
          options={PAYER_PAYEE_TYPES.map((item) => ({
            value: item.value,
            label: trb(translationGroups.PayerPayeeTypes + item.label),
          }))}
        />
      </FormField>
      {values.Payment.InitPayerType ? (
        <>
          <FormField
            name="Payment.InitPayerName"
            label={trb(i18.Labels.InitTitle)}
          >
            <Input />
          </FormField>
          <FieldIdentificationType
            name="Payment.InitPayerIdentTypeCode"
            type={values.Payment.InitPayerType}
            label="InitPayerIdentificationType"
          />
          <FormField
            name="Payment.InitPayerIdentTypeValue"
            label={trb(i18.Labels.InitPayerIdentificationCode)}
          >
            <Input />
          </FormField>
        </>
      ) : null}
    </div>
  );
};
